export default __webpack_public_path__ + "static/media/landing-category-image.151e120c.png";